/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const LabSwitcherArrowSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 18 26.1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#505776" className="lab-switcher__arrow--svg" d="M9.1,3.2c-1.8,1.9-4,4.1-5.4,5.6-2.2,2.3-2.2,6.3,0,8.5,1.4,1.5,3.6,3.7,5.4,5.6,2.5,2.6,6.9.8,6.9-2.8V6c0-3.6-4.4-5.4-6.9-2.8Z"/>
    <path fill="#FFFFFF" d="M14.3.4C12-.5,9.4,0,7.7,1.8c-1.8,1.9-4,4.1-5.4,5.6h0s-.7.8-.7.8l-.6.8c-1.7,3.1-1.3,7.1,1.2,9.7,1.4,1.5,3.6,3.7,5.4,5.6,1.2,1.2,2.7,1.8,4.3,1.8s1.5-.1,2.3-.4c2.3-.9,3.7-3.1,3.7-5.6V6c0-2.5-1.5-4.6-3.7-5.6ZM14,20.1c0,1.2-1,1.7-1.2,1.9-.3.1-1.3.4-2.2-.5-1.8-1.9-4-4.1-5.5-5.6-1.5-1.5-1.5-4.2,0-5.7l-.3-.3h0s.3.3.3.3c1.4-1.5,3.6-3.7,5.5-5.6.9-.9,1.9-.6,2.2-.5.3.1,1.2.6,1.2,1.9v14.1Z"/>
  </svg>
);

export const LabSwitcherArrowIcon = props => {
  return (
    <Icon component={() => <LabSwitcherArrowSvg />} {...props} />
  );
};
